import text from "@techweb/assets/text.json";

export const getTexts = () => text;
